import { Box } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ControlledCheckbox, Label } from '@components';

export const DebtTypes = () => {
  const { t } = useTranslation('subModules/debtTypes');
  const fields: { [key: string]: string } = t('fields', {
    returnObjects: true,
  }) as { [key: string]: string };
  const { setValue, watch, trigger } = useFormContext();
  const values = watch('debtTypes') || [];

  const handleCheckboxChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    key: string
  ) => {
    const updatedValues = event.target.checked
      ? [...values, key]
      : values.filter((item: string) => item !== key);

    setValue('debtTypes', updatedValues);
    trigger('debtTypes');
  };

  return (
    <Box
      id="debtTypes"
      data-testid="debtTypesSubModule"
      data-tf-sensitive="true"
    >
      <Label required>{t('label')}</Label>

      <ControlledCheckbox
        name="debtTypes"
        fields={fields}
        handleCheckboxChange={handleCheckboxChange}
      />
    </Box>
  );
};
